import { API } from "../api";

const BASE_URL = "/members/birthday";

const memberBirthdayApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getTodayBirthdays: builder.query({
      query: (page = 1) => `${BASE_URL}/today?guard=member&page=${page}`,
      transformResponse: (responseData) => responseData.data,
      providesTags: ["TodayBirthdays"],
    }),
    sendBirthdayWish: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}/send-wish?guard=member`,
        method: "POST",
        body,
      }),
      // Invalidate both lists to ensure immediate updates
      invalidatesTags: ["TodayBirthdays", "ReceivedWishes"],
    }),
    getReceivedWishes: builder.query({
      query: (page = 1) => `${BASE_URL}/received-wishes?guard=member&page=${page}`,
      transformResponse: (responseData) => responseData.data,
      providesTags: ["ReceivedWishes"],
    }),
    getMemberBirthdayVisibility: builder.query({
      query: () => `${BASE_URL}/visibility?guard=member`,
      transformResponse: (responseData) => responseData.data,
      providesTags: ["BirthdayVisibility"],
    }),
    updateMemberBirthdayVisibility: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}/visibility/update?guard=member`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["BirthdayVisibility"],
    }),
  }),
});

export const {
  useGetTodayBirthdaysQuery,
  useGetReceivedWishesQuery,
  useSendBirthdayWishMutation,
  useGetMemberBirthdayVisibilityQuery,
  useUpdateMemberBirthdayVisibilityMutation,
} = memberBirthdayApi;

